const useRouterErrorHandling = () => {
    interface ErrorEvent {
        message: string;
    }

    const handleError = (error: ErrorEvent) => {
        if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes("Importing a module script failed")) {
            window.location.reload();
        }
    };

    window.addEventListener('error', handleError);

};

export default useRouterErrorHandling;